__turbopack_context__.v({
  "passport_button": "PassportHoverOverlay-module-scss-module__TeBjGq__passport_button",
  "passport_hover_overlay": "PassportHoverOverlay-module-scss-module__TeBjGq__passport_hover_overlay",
  "passport_hover_overlay_text": "PassportHoverOverlay-module-scss-module__TeBjGq__passport_hover_overlay_text",
});
